import _ from "underscore";
import {arrayToSet} from "../atUtils";

export default class EntityStore {
    constructor()
    {
        this._map = {};
        this._array = [];
        this._orderIndex = {};
    }

    mergeAll(entities)
    {
        _.each(entities, entity => this.add(entity))
    }

    replaceAll(entities)
    {
        this._map = {};
        this._array = [];
        this.mergeAll(entities);
    }

    add(entity)
    {
        if (_.isObject(entity))
            entity = Object.freeze(entity);

        const id = this.getEntityId(entity);
        let oldEntity = this._map[id];

        if (!oldEntity)
        {
            this._array.push(entity);
            this._orderIndex[id] = this._array.length - 1;
            this._onAdd(entity, null, false);
        }
        else
        {
            this._array[this._orderIndex[id]] = entity;
            this._onAdd(entity, oldEntity, false);
        }

        this._map[id] = entity;
        return oldEntity;
    }

    addFirst(item)
    {
        this.addManyFirst([item]);
    }

    addManyFirst(entities)
    {
        const newArray = [];
        const newEntitiesSet = {};

        _.each(entities, entity =>
        {
            if (_.isObject(entity))
                entity = Object.freeze(entity);

            const id = this.getEntityId(entity);
            if (!newEntitiesSet[id])
            {
                const oldEntity = this._map[id];
                if (oldEntity)
                {
                    this._array[this._orderIndex[id]] = entity;
                    this._onAdd(entity, oldEntity, true);
                }
                else
                {
                    newArray.push(entity);
                    this._orderIndex[id] = newArray.length - 1;
                    this._onAdd(entity, null, true);
                }

                this._map[id] = entity;
                newEntitiesSet[id] = true;
            }
        });

        _.each(this._array, entity =>
        {
            const id = this.getEntityId(entity);
            newArray.push(entity);
            this._orderIndex[id] = newArray.length - 1;
        });

        this._array = newArray;
    }

    remove(id)
    {
        this.removeMany([id]);
    }

    removeMany(ids)
    {
        this._orderIndex = {};

        const idsToRemoveSet = arrayToSet(ids);
        const newArray = [];
        _.each(this._array, entity =>
        {
            const id = this.getEntityId(entity);
            if (!idsToRemoveSet[id])
            {
                newArray.push(entity);
                this._orderIndex[id] = newArray.length - 1;
            }
            else
            {
                delete this._map[id];
                this._onRemove(entity);
            }
        });

        this._array = newArray;
    }

    get(id)
    {
        return this._map[id];
    }

    getAll()
    {
        return this._array;
    }

    getAllMap()
    {
        return this._map;
    }

    getEntityId(entity)
    {
        return entity
    }

    _onAdd(newEntity, oldEntity, first)
    {
    }

    _onRemove(entity)
    {
    }
};



// WEBPACK FOOTER //
// ./web/js/store/EntityStore.js